import React, { createContext, FC, ReactNode, useEffect, useMemo } from 'react';

import { MeQuery, Scope, useMeQuery } from '../types/api.graphql';
import { logErrorToMonitorSystem } from '../utils/errorLogging';

type Nullable<T> = T | null;

interface SessionContextProps {
  me: Nullable<MeQuery['me']>;
  isAdmin: boolean;
  loading: boolean;
}

interface SessionProviderProps {
  children: ReactNode;
}

const SessionContext = createContext<SessionContextProps>({ me: null, isAdmin: false, loading: null });

export const SessionProvider: FC<SessionProviderProps> = ({ children }) => {
  const { data, loading } = useMeQuery();

  const isAdmin = useMemo(() => data?.me?.scopes?.includes(Scope.Admin) || false, [data]);

  useEffect(() => {
    const identifyUser = () => {
      try {
        if (window['hj'] && data?.me?.id && data?.me?.email) {
          window['hj']('identify', data.me.id, {
            email: data.me.email,
          });
        } else {
          console.warn('Hotjar is not loaded or user data is incomplete.');
        }
      } catch (error: any) {
        logErrorToMonitorSystem(error);
      }
    };

    identifyUser();
  }, [data]);

  return (
    <SessionContext.Provider
      value={{
        me: data?.me || null,
        isAdmin,
        loading: loading || null,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export const useSessionContext: () => SessionContextProps = () => {
  return React.useContext(SessionContext);
};
